import { router } from '@inertiajs/vue3';
import { Classroom } from '@/app/api/models/classroom';
import { SessionModule } from '@/app/api/models/sessionModule';
import { Module } from '@/app/api/models/module';
import { Session } from '@/app/api/models/session';
import { disableFullScreen } from '@/utils/utils';
import PusherService from '@/app/services/PusherService';

/**
 * 선생님 관리자 홈
 */
export function goTeacherPage() {
    window.location.href = route('teacher.dashboard');
}

/**
 * 선생님 로그인
 */
export function goTeacherLogin() {
    window.location.href = route('teacher.login');
}

/**
 * 학급 홈
 */
export function goClassroomHome(classroom: Classroom) {
    router.get(route('app.teacher.home', classroom));
}

/**
 * 학급 활동 설정
 */
export function goClassroomModuleSetting(classroom: Classroom, module: Module) {
    router.get(
        route('app.teacher.module.setting', {
            classroom,
            module,
        }),
    );
}

/**
 * 학급 활동 진행
 */
export function goClassroomInPlay(classroom: Classroom) {
    router.get(
        route('app.teacher.in-play', {
            classroom,
        }),
        {},
        { replace: true },
    );
}

/**
 * 학급 활동 결과
 */
export function goClassroomSessionModuleResult(classroom: Classroom, sessionModule: SessionModule) {
    router.get(
        route('app.teacher.session-modules.result', {
            classroom,
            sessionModule,
        }),
        {},
        { replace: true },
    );
}

/**
 * 선생님 수업 결과
 */
export function goTeacherSessionResult(classroom: Classroom, session: Session) {
    router.get(
        route('app.teacher.sessions.result', {
            classroom,
            session,
        }),
    );
}

/**
 * 학생 수업 결과
 */
export function goSessionResult(session: Session | number) {
    router.get(
        route('app.sessions.result', {
            session,
        }),
        {},
        { replace: true },
    );
}

/**
 * 학생 로그인
 */
export function goStudentLogin() {
    router.get(route('app.login'));
}

/**
 * 학생 홈
 */
export function goStudentPage() {
    window.location.href = route('app.home');
}

/**
 * 학생 별뽑기 페이지
 */
export function goAvatarsPage() {
    router.get(route('app.avatars.index'));
}

/**
 * 학생 활동 진행
 */
export function goStudentInPlay() {
    router.get(route('app.in-play'), {}, { replace: true });
}

/**
 * 학생 활동 결과
 */
export function goStudentSessionModuleResult(sessionModule: SessionModule) {
    router.get(
        route('app.session-modules.result', {
            sessionModule,
        }),
        {},
        { replace: true },
    );
}

/**
 * 로그아웃
 */
export function goLogout() {
    PusherService.getInstance().unsubscribeClassChannel();
    router.post(route('app.logout'));
    disableFullScreen(); // 전체화면 해제
}
